import $ from 'jquery';
import fetch from 'utils/fetch';
import { error } from './toastr';

export default function bind() {
  $('.button.delete:not(.selection)').on('click', evt => {
    evt.preventDefault();

    const $button = $(evt.currentTarget);

    const url = $button.attr('data-url');
    const data = $button.attr('data-body');

    if (url) {
      displayModal(
        '.modal.delete',
        () => deletePromise(url, data),
        promise => {
          promise.then(
            res => {
              $('form.dirty').removeClass('dirty');
              window.location.replace(res.url);
            },
            err => {
              console.log(error);
              error('Une erreur est survenue pendant la suppression');
            }
          );
        }
      );
    }
  });
  $('.button.delete-site:not(.selection)').on('click', evt => {
    evt.preventDefault();

    const $button = $(evt.currentTarget);

    const url = $button.attr('data-url');
    const data = $button.attr('data-body');

    if (url) {
      displayModal(
        '.modal.delete-site',
        () => deletePromise(url, data),
        promise => {
          promise.then(
            res => {
              $('form.dirty').removeClass('dirty');
              window.location.replace(res.url);
            },
            err => {
              console.log(error);
              error('Une erreur est survenue pendant la suppression');
            }
          );
        }
      );
    }
  });
}

export function displayModal(name, promiseFunc, cb) {
  const $modal = $(name);

  $modal
    .modal({
      onApprove: element => {
        $(element).addClass('loading');
        const promise = promiseFunc().then(
          res => {
            $(element).removeClass('loading');
            $modal.modal('hide');

            return res;
          },
          err => {
            console.log('Error attempting to delete entity', err);
            $(element).removeClass('loading');

            return Promise.reject(err);
          }
        );

        cb(promise);

        return false;
      },
    })
    .modal('show');
}

function deletePromise(url, data = undefined) {
  return fetch(url, {
    method: 'DELETE',
    body: data,
  });
}



// WEBPACK FOOTER //
// ./src/plugins/confirm-delete.js